import { EditorFormProps } from '@/context/Microsite';
import { useFormContext } from 'react-hook-form';

export const useMicrositeCtx = () => {
  return useFormContext<EditorFormProps>();
};
